class ScrollToSectionButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.currentSection = this.closest("section");

    this.scrollFooter = this.dataset.scrollFooter;

    if (this.scrollFooter === "true") {
      this.followingSection = document.querySelector("footer.footer");
    } else {
      this.followingSection = this.currentSection.nextElementSibling;
    }

    this.addEventListener("click", () => {
      this.scrollToSection();
    });
  }

  scrollToSection() {
    this.followingSection.scrollIntoView({ behavior: "smooth" });
  }
}

customElements.define("scroll-to-section-button", ScrollToSectionButton);
